<template>
  <div class="order-stat">
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">订单号：</span>
            <el-input v-model="searchInfo.orderNo" clearable placeholder="请输入订单号"></el-input>
          </div>
          <div class="search-item">
            <span class="label">发货状态：</span>
            <el-select v-model="searchInfo.shipStatus" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in shipStatusList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">买方手机号：</span>
            <el-input v-model="searchInfo.receiverPhone" clearable placeholder="请输入用户ID"></el-input>
          </div>
          <div class="search-item">
            <span class="label">卖方手机号：</span>
            <el-input v-model="searchInfo.senderPhone" clearable placeholder="请输入用户ID"></el-input>
          </div>
          <div class="search-item">
            <span class="label">运单号：</span>
            <el-input v-model="searchInfo.logisticCode" clearable placeholder="请输入运单号"></el-input>
          </div>
          <div class="search-item">
            <span class="label">快递公司：</span>
            <el-select v-model="searchInfo.expressCompanyName" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in expressCompanyList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="600px" @row-dblclick="handleRowDblClick">
        <el-table-column type="index" width="50"></el-table-column>
        <!-- <el-table-column prop="id" label="发货记录ID" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderId" label="订单ID" width="110" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column prop="userId" label="用户ID" width="110" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="orderNo" label="订单号" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deliveryAmount" label="预估费用" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>¥{{ scope.row.deliveryAmount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="expressCompanyName" label="快递公司" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="logisticCode" label="运单号" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shipStatus" label="发货状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="getShipStatusTagType(scope.row.shipStatus)">
              {{ getShipStatusText(scope.row.shipStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="senderName" label="寄件人" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="senderPhone" label="寄件电话" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="receiverName" label="收件人" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="receiverPhone" label="收件电话" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pickupDate" label="期望上门日期" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pickupTimeSlot" label="上门时间段" width="130" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shipErrorMessage" label="失败原因" min-width="80" show-overflow-tooltip></el-table-column>

        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 物流详情弹窗 -->
    <el-dialog
      title="物流详情"
      :visible.sync="orderDetailVisible"
      width="1100px"
      :before-close="handleClose"
      custom-class="order-detail-dialog">
      <div v-if="orderDetail" class="order-detail-wrapper">
        <div class="order-detail">
          <!-- 订单基本信息卡片 -->
          <div class="detail-card order-header-card">
            <div class="card-header">
              <span class="card-title">基本信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">订单号</span>
                    <span class="item-value">{{ orderDetail.orderNo || '--' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">订单状态</span>
                    <span class="item-value">
                      <el-tag v-if="orderDetail.status" :type="getStatusTagType(orderDetail.status)" size="small">
                        {{ getStatusText(orderDetail.status) }}
                      </el-tag>
                      <span v-else>--</span>
                    </span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">创建时间</span>
                    <span class="item-value">{{ orderDetail.createTime || '--' }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 交易信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">交易信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">买家ID</span>
                    <span class="item-value">{{ orderDetail.buyerId || '--' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">卖家ID</span>
                    <span class="item-value">{{ orderDetail.sellerId || '--' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">商品ID</span>
                    <span class="item-value">{{ orderDetail.productId || '--' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 16px;">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">发货方式</span>
                    <span class="item-value">{{ orderDetail.shippingMethod ? getShippingMethodText(orderDetail.shippingMethod) : '--' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">支付流水</span>
                    <span class="item-value">{{ orderDetail.payNo || '--' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">买家留言</span>
                    <span class="item-value">{{ orderDetail.buyerMessage || '--' }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 收货地址卡片 -->
          <div class="detail-card" v-if="orderDetail.addressSnapshot">
            <div class="card-header">
              <span class="card-title">收货地址</span>
            </div>
            <div class="card-body">
              <div class="address-info">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">收货人</span>
                      <span class="item-value">{{ getAddressInfo(orderDetail.addressSnapshot, 'receiverName') || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">联系电话</span>
                      <span class="item-value">{{ getAddressInfo(orderDetail.addressSnapshot, 'receiverPhone') || '--' }}</span>
                    </div>
                  </el-col>
                </el-row>
                <div class="detail-item" style="margin-top: 16px;">
                  <span class="item-label">收货地址</span>
                  <span class="item-value">
                    <template v-if="getAddressInfo(orderDetail.addressSnapshot, 'province') || getAddressInfo(orderDetail.addressSnapshot, 'city')">
                      {{ getAddressInfo(orderDetail.addressSnapshot, 'province') }}
                      {{ getAddressInfo(orderDetail.addressSnapshot, 'city') }}
                      {{ getAddressInfo(orderDetail.addressSnapshot, 'district') }}
                      {{ getAddressInfo(orderDetail.addressSnapshot, 'detailAddress') }}
                    </template>
                    <template v-else>--</template>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 商品信息卡片 -->
          <div class="detail-card" v-if="orderDetail.productSnapshot">
            <div class="card-header">
              <span class="card-title">商品信息</span>
            </div>
            <div class="card-body">
              <div class="product-info">
                <div class="product-info-layout">
                  <div class="product-image-wrapper" v-if="getProductInfo(orderDetail.productSnapshot, 'coverImage')">
                    <el-image
                      :src="getProductInfo(orderDetail.productSnapshot, 'coverImage').split(';')[0]"
                      class="product-image"
                      fit="cover"
                      :preview-src-list="[getProductInfo(orderDetail.productSnapshot, 'coverImage').split(';')[0]]"
                    />
                  </div>
                  <div class="product-image-wrapper" v-else>
                    <div class="product-image-placeholder">暂无图片</div>
                  </div>
                  <div class="product-details">
                    <div class="product-title">{{ getProductInfo(orderDetail.productSnapshot, 'title') || '暂无标题' }}</div>
                    <div class="product-meta">
                      <div class="meta-item">
                        <span class="meta-label">商品ID</span>
                        <span class="meta-value">{{ getProductInfo(orderDetail.productSnapshot, 'id') || '--' }}</span>
                      </div>
                      <div class="meta-item" v-if="getProductInfo(orderDetail.productSnapshot, 'originalPrice')">
                        <span class="meta-label">原价</span>
                        <span class="meta-value price-original">¥{{ getProductInfo(orderDetail.productSnapshot, 'originalPrice') }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">售价</span>
                        <span class="meta-value price-sale">¥{{ getProductInfo(orderDetail.productSnapshot, 'price') || 0 }}</span>
                      </div>
                      <div class="meta-item" v-if="getProductInfo(orderDetail.productSnapshot, 'province') || getProductInfo(orderDetail.productSnapshot, 'city')">
                        <span class="meta-label">地区</span>
                        <span class="meta-value">
                          {{ getProductInfo(orderDetail.productSnapshot, 'province') }}
                          {{ getProductInfo(orderDetail.productSnapshot, 'city') }}
                          {{ getProductInfo(orderDetail.productSnapshot, 'district') }}
                        </span>
                      </div>
                    </div>
                    <div class="product-desc-section" v-if="getProductInfo(orderDetail.productSnapshot, 'description')">
                      <span class="desc-label">商品描述</span>
                      <div class="product-description">
                        {{ getProductInfo(orderDetail.productSnapshot, 'description') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 费用信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">费用信息</span>
            </div>
            <div class="card-body">
              <div class="price-info">
                <el-row :gutter="16">
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">商品金额</div>
                      <div class="price-value">¥{{ orderDetail.productAmount || 0 }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">运费</div>
                      <div class="price-value">¥{{ orderDetail.shippingFee || 0 }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">订单总额</div>
                      <div class="price-value">¥{{ orderDetail.totalAmount || 0 }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item price-item-highlight">
                      <div class="price-label">实付金额</div>
                      <div class="price-value">¥{{ orderDetail.payAmount || 0 }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 20px;">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">支付超时</span>
                      <span class="item-value">{{ orderDetail.payExpireTime || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">支付时间</span>
                      <span class="item-value">{{ orderDetail.paidAt || '--' }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 16px;">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">发货时间</span>
                      <span class="item-value">{{ orderDetail.shippedAt || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">收货时间</span>
                      <span class="item-value">{{ orderDetail.receivedAt || '--' }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <!-- 物流信息卡片 -->
          <div class="detail-card" v-if="orderDetail.logistics">
            <div class="card-header">
              <span class="card-title">物流信息</span>
            </div>
            <div class="card-body">
              <div class="logistics-info">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">物流公司</span>
                      <span class="item-value">{{ orderDetail.logistics.companyName || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">运单号</span>
                      <span class="item-value">{{ orderDetail.logistics.trackingNo || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">物流状态</span>
                      <span class="item-value">{{ orderDetail.logistics.status || '--' }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 发货弹窗 -->
    <el-dialog
      title="订单发货"
      :visible.sync="shipDialogVisible"
      width="500px">
      <el-form :model="shipForm" :rules="shipRules" ref="shipForm" label-width="100px">
        <el-form-item label="物流公司" prop="logisticsCompany">
          <el-input v-model="shipForm.logisticsCompany" placeholder="请输入物流公司"></el-input>
        </el-form-item>
        <el-form-item label="运单号" prop="trackingNo">
          <el-input v-model="shipForm.trackingNo" placeholder="请输入运单号"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="shipForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入发货备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="shipDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitShip" :loading="shipping">确定发货</el-button>
      </div>
    </el-dialog>

    <!-- 更新状态弹窗 -->
    <el-dialog
      title="更新订单状态"
      :visible.sync="statusDialogVisible"
      width="400px">
      <el-form :model="statusForm" label-width="80px">
        <el-form-item label="订单状态">
          <el-select v-model="statusForm.status" placeholder="请选择状态" style="width: 100%;">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="statusForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statusDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitStatusUpdate">确定</el-button>
      </div>
    </el-dialog>

    <!-- 用户详情对话框 -->
    <user-detail-dialog
      :visible.sync="userDetailVisible"
      :user-id="selectedUserId">
    </user-detail-dialog>

    <!-- 商品详情对话框 -->
    <product-detail-dialog
      :visible.sync="productDetailVisible"
      :product-id="selectedProductId">
    </product-detail-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import UserDetailDialog from '../common/user-detail-dialog.vue';
  import ProductDetailDialog from '../common/product-detail-dialog.vue';

  export default {
    name: "order-stat",
    components: {
      UserDetailDialog,
      ProductDetailDialog
    },
    data () {
      return {
        // 表格数据
        total: 0,
        tableData: [],
        searchDateArr: [],
        loading: false,
        currentPage: 1,
        shipping: false,
        // 弹窗控制
        orderDetailVisible: false,
        shipDialogVisible: false,
        statusDialogVisible: false,
        orderDetail: null,
        currentOrder: null,
        // 发货表单
        shipForm: {
          id: null,
          logisticsCompany: '',
          trackingNo: '',
          remark: ''
        },
        // 状态更新表单
        statusForm: {
          id: null,
          status: '',
          remark: ''
        },
        // 用户详情弹窗
        userDetailVisible: false,
        selectedUserId: null,
        // 商品详情弹窗
        productDetailVisible: false,
        selectedProductId: null,
        // 搜索条件
        searchInfo: {
          orderNo: '',
          shipStatus: '',
          userId: '',
          orderId: '',
          receiverPhone : '',
          senderPhone : '',
          logisticCode: '',
          expressCompanyName: '',
          pageNumber: 0,
          pageSize: 10,
        },
        // 下拉列表数据
        shipStatusList: [
          { label: '待提交', value: 1 },
          { label: '已提交', value: 2 },
          { label: '提交失败', value: 3 },
          { label: '下单成功', value: 4 },
          { label: '下单失败', value: 5 },
          { label: '取消处理中', value: 6 },
          { label: '取消订单（用户取消）', value: 7 },
          { label: '取消订单（快递取消）', value: 8 },
          { label: '网点信息（取件码）', value: 9 },
          { label: '快递员信息', value: 10 },
          { label: '取件状态', value: 11 },
          { label: '揽件', value: 12 },
          { label: '在途中', value: 13 },
          { label: '签收状态', value: 14 }
        ],
        expressCompanyList: [
          { label: '中通', value: 'ZTO' },
          { label: '圆通', value: 'YTO' },
          { label: '申通', value: 'STO' },
          { label: '顺丰', value: 'SF' },
          { label: '韵达', value: 'YUNDA' },
          { label: '京东', value: 'JD' }
        ],
        statusList: [
          { label: '待支付', value: 1 },
          { label: '待发货', value: 2 },
          { label: '待收货', value: 3 },
          { label: '待评价', value: 4 },
          { label: '已完成', value: 5 },
          { label: '已取消', value: 6 },
          { label: '退款中', value: 7 },
          { label: '已退款', value: 8 }
        ],
        // 表单验证规则
        shipRules: {
          logisticsCompany: [
            { required: true, message: '请输入物流公司', trigger: 'blur' }
          ],
          trackingNo: [
            { required: true, message: '请输入运单号', trigger: 'blur' }
          ]
        },
        // 日期选择器配置
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    watch: {
      'searchInfo.orderNo'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      },
      'searchInfo.userId'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      },
      'searchInfo.orderId'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      },
      'searchInfo.logisticCode'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      },
      'searchInfo.expressCompanyName'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      }
    },
    created() {
      this.getOrderList();
    },
    methods: {
      // 搜索
      search() {
        this.currentPage = 1;
        this.searchInfo.pageNumber = 0;
        this.getOrderList();
      },

      // 分页处理
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val - 1;
        this.getOrderList();
      },

      handleSizeChange(val) {
        this.currentPage = 1;
        this.searchInfo.pageSize = val;
        this.searchInfo.pageNumber = 0;
        this.getOrderList();
      },

      // 获取订单列表
      getOrderList() {
        if (this.loading) return;
        this.loading = true;

        axios.get('/orderShipment/list', {
          params: this.searchInfo
        }).then(result => {
          this.loading = false;
          if (result.code === 200) {
            const pageInfo = result.data || {};
            this.total = pageInfo.total || 0;
            this.tableData = pageInfo.list || [];
          } else {
            this.$message.error(result.message || '获取数据失败');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$message.error('网络异常，请重试');
        });
      },

      getShipStatusText(status) {
        const map = {
          1: '待提交',
          2: '已提交',
          3: '提交失败',
          4: '下单成功',
          5: '下单失败',
          6: '取消处理中',
          7: '取消订单（用户取消）',
          8: '取消订单（快递取消）',
          9: '网点信息（取件码）',
          10: '快递员信息',
          11: '取件状态',
          12: '揽件',
          13: '在途中',
          14: '签收状态'
        };
        return map[status] || '--';
      },

      getShipStatusTagType(status) {
        const map = {
          1: 'info',
          2: 'success',
          3: 'danger'
        };
        return map[status] || 'info';
      },

      // 查看物流详情
      viewDetail(row) {
        this.getOrderDetail(row.id);
      },

      // 获取物流详情
      getOrderDetail(id) {
        axios.get(`/orderShipment/${id}`).then(result => {
          if (result.code === 200) {
            this.orderDetail = result.data;
            this.orderDetailVisible = true;
          } else {
            this.$message.error('获取物流详情失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 显示发货弹窗
      showShipDialog(row) {
        this.currentOrder = row;
        this.shipForm = {
          id: row.id,
          logisticsCompany: '',
          trackingNo: '',
          remark: ''
        };
        this.shipDialogVisible = true;
      },

      // 提交发货
      submitShip() {
        this.$refs.shipForm.validate((valid) => {
          if (valid) {
            this.shipping = true;
            axios.post(`/admin/order/${this.shipForm.id}/ship`, {
              logisticsCompany: this.shipForm.logisticsCompany,
              trackingNo: this.shipForm.trackingNo,
              remark: this.shipForm.remark
            }).then(result => {
              this.shipping = false;
              if (result.code === 200) {
                this.$message.success('发货成功');
                this.shipDialogVisible = false;
                this.getOrderList();
              } else {
                this.$message.error(result.message || '发货失败');
              }
            }).catch(err => {
              console.error(err);
              this.shipping = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },

      // 显示状态更新弹窗
      showStatusDialog(row) {
        this.currentOrder = row;
        this.statusForm = {
          id: row.id,
          status: row.status,
          remark: ''
        };
        this.statusDialogVisible = true;
      },

      // 提交状态更新
      submitStatusUpdate() {
        axios.put(`/admin/order/${this.statusForm.id}/status`, {
          status: this.statusForm.status,
          remark: this.statusForm.remark
        }).then(result => {
          if (result.code === 200) {
            this.$message.success('状态更新成功');
            this.statusDialogVisible = false;
            this.getOrderList();
          } else {
            this.$message.error(result.message || '状态更新失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常,请重试');
        });
      },

      // 双击行事件
      handleRowDblClick(row) {
        this.viewDetail(row);
      },

      // 关闭弹窗
      handleClose(done) {
        this.orderDetail = null;
        done();
      },

      // 工具方法
      getStatusText(status) {
        const statusMap = {
          1: '待支付',
          2: '待发货',
          3: '待收货',
          4: '待评价',
          5: '已完成',
          6: '已取消',
          7: '退款中',
          8: '已退款'
        };
        return statusMap[status] || '未知';
      },

      getStatusTagType(status) {
        const typeMap = {
          1: 'warning',
          2: 'primary',
          3: 'info',
          4: 'success',
          5: 'success',
          6: 'danger',
          7: 'warning',
          8: 'danger'
        };
        return typeMap[status] || 'info';
      },

      getShippingMethodText(shippingMethod) {
        const shippingMethodMap = {
          1: '邮寄',
          2: '面交'
        };
        return shippingMethodMap[shippingMethod] || '未知';
      },

      // 解析商品快照数据
      getProductInfo(productSnapshot, field) {
        try {
          if (typeof productSnapshot === 'string') {
            const product = JSON.parse(productSnapshot);
            return product[field] || '';
          } else if (typeof productSnapshot === 'object' && productSnapshot !== null) {
            return productSnapshot[field] || '';
          }
          return '';
        } catch (e) {
          console.error('解析商品快照失败:', e);
          return '';
        }
      },

      // 解析地址快照数据
      getAddressInfo(addressSnapshot, field) {
        try {
          if (typeof addressSnapshot === 'string') {
            const address = JSON.parse(addressSnapshot);
            return address[field] || '';
          } else if (typeof addressSnapshot === 'object' && addressSnapshot !== null) {
            return addressSnapshot[field] || '';
          }
          return '';
        } catch (e) {
          console.error('解析地址快照失败:', e);
          return '';
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .order-stat {
    .stats-cards {
      margin-bottom: 20px;

      .el-col {
        min-width: 280px;
        margin-top: 30px;
      }

      .stats-card {
        background: #fff;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        min-width: 260px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
        }

        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
          margin-right: 16px;
          flex-shrink: 0;

          &.total {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
          &.paid {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          }
          &.amount {
            background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          }
          &.paid-amount {
            background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
          }
        }

        .stats-content {
          flex: 1;
          min-width: 0;

          .stats-number {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            line-height: 1.2;
            word-break: break-all;
          }
          .stats-label {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
            white-space: nowrap;
          }
        }
      }
    }
  }

  // 物流详情弹窗样式
  /deep/ .order-detail-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #e8eaec;
      padding: 20px 24px;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }
    }

    .el-dialog__body {
      padding: 0;
      background: #f5f7fa;
    }
  }

  .order-detail-wrapper {
    padding: 20px;
  }

  .order-detail {
    // 卡片基础样式
    .detail-card {
      background: #fff;
      border-radius: 8px;
      margin-bottom: 16px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }

      .card-header {
        padding: 16px 20px;
        background: linear-gradient(90deg, #f7f8fa 0%, #fff 100%);
        border-bottom: 1px solid #ebeef5;

        .card-title {
          font-size: 15px;
          font-weight: 600;
          color: #303133;
          position: relative;
          padding-left: 12px;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 16px;
            background: #409EFF;
            border-radius: 2px;
          }
        }
      }

      .card-body {
        padding: 20px;
      }
    }

    // 详情项样式
    .detail-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 0;

      .item-label {
        color: #909399;
        font-size: 14px;
        min-width: 80px;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .item-value {
        color: #303133;
        font-size: 14px;
        flex: 1;
        word-break: break-all;
      }
    }

    // 收货地址样式
    .address-info {
      .detail-item {
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    // 商品信息样式
    .product-info {
      .product-info-layout {
        display: flex;
        gap: 20px;
        align-items: flex-start;
      }

      .product-image-wrapper {
        flex-shrink: 0;
      }

      .product-image {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        cursor: pointer;
        transition: transform 0.2s;
        
        &:hover {
          transform: scale(1.02);
        }
      }

      .product-image-placeholder {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        background: #f5f7fa;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #909399;
        font-size: 14px;
      }

      .product-details {
        flex: 1;
        min-width: 0;

        .product-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 12px;
          line-height: 1.5;
          word-break: break-all;
        }

        .product-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          margin-bottom: 16px;
          
          .meta-item {
            display: flex;
            align-items: center;
            gap: 8px;
            
            .meta-label {
              color: #909399;
              font-size: 14px;
              flex-shrink: 0;
            }
            
            .meta-value {
              color: #303133;
              font-size: 14px;
            }
          }
        }

        .price-original {
          color: #909399;
          text-decoration: line-through;
        }

        .price-sale {
          color: #f56c6c;
          font-weight: 600;
          font-size: 16px;
        }

        .product-desc-section {
          .desc-label {
            display: block;
            color: #909399;
            font-size: 14px;
            margin-bottom: 8px;
          }
        }

        .product-description {
          padding: 12px 16px;
          background: linear-gradient(135deg, #f8f9fa 0%, #f5f7fa 100%);
          border-radius: 8px;
          color: #606266;
          font-size: 13px;
          line-height: 1.8;
          max-height: 150px;
          overflow-y: auto;
          word-break: break-all;

          &::-webkit-scrollbar {
            width: 6px;
          }

          &::-webkit-scrollbar-thumb {
            background: #dcdfe6;
            border-radius: 3px;
          }

          &::-webkit-scrollbar-track {
            background: #f5f7fa;
          }
        }
      }
    }

    // 费用信息样式
    .price-info {
      .price-item {
        text-align: center;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        transition: all 0.3s;

        &:hover {
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
          border-color: #c6e2ff;
        }

        .price-label {
          font-size: 13px;
          color: #909399;
          margin-bottom: 8px;
        }

        .price-value {
          font-size: 20px;
          font-weight: 600;
          color: #303133;
        }

        &.price-item-highlight {
          background: linear-gradient(135deg, #fff6e6 0%, #ffecd0 100%);
          border-color: #ffd591;

          .price-value {
            color: #e6a23c;
            font-size: 24px;
          }
        }
      }

      .detail-item {
        margin-bottom: 0;
      }
    }

    // 物流信息样式
    .logistics-info {
      .detail-item {
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-left: 8px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    font-size: 12px;
  }

  @media screen and (max-width: 992px) {
    .order-stat .stats-cards {
      .el-col {
        min-width: 45%;
        margin-bottom: 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }

    .order-stat .stats-cards {
      .el-col {
        margin-bottom: 16px;
        min-width: 100%;
      }

      .stats-card {
        min-width: auto;
      }
    }

    .order-detail-wrapper {
      padding: 12px;
    }

    .order-detail {
      .detail-card {
        .card-body {
          padding: 16px;
        }
      }

      .detail-item {
        flex-direction: column;
        align-items: flex-start;

        .item-label {
          margin-bottom: 4px;
        }
      }

      .price-info {
        .el-col {
          margin-bottom: 12px;
        }

        .price-item {
          padding: 12px;

          .price-value {
            font-size: 18px;
          }

          &.price-item-highlight .price-value {
            font-size: 20px;
          }
        }
      }

      .product-info {
        .product-info-layout {
          flex-direction: column;
        }
        
        .product-image {
          width: 100px;
          height: 100px;
        }
        
        .product-meta {
          gap: 12px;
          
          .meta-item {
            width: 100%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 480px) {
    .order-stat .stats-cards {
      .stats-card {
        padding: 16px;

        .stats-icon {
          width: 50px;
          height: 50px;
          font-size: 20px;
          margin-right: 12px;
        }

        .stats-content {
          .stats-number {
            font-size: 20px;
          }
          .stats-label {
            font-size: 12px;
          }
        }
      }
    }
  }

  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }

  /deep/ .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  /deep/ .el-divider__text {
    background: #fff;
    font-weight: 500;
    color: #303133;
  }

  /deep/ .el-table .warning-row {
    background: #fdf6ec;
  }

  /deep/ .el-table .success-row {
    background: #f0f9ff;
  }
</style>
